// Utility to read selected metrics
export const getMetricsFromList = (arr: { [x: string]: {
  show: boolean; metric: any;
}; }) => {
  const result = [];
    for(const key in arr) { if (arr[key].show === true) result.push(arr[key].metric); }
  return result;
  }

  export const getMetricTable = (metricList) => {
    const updatedMetricColumns = metricList.map(item => ({ metric: item, show: true }));
    return updatedMetricColumns;
  };
